import { type CrudList } from "@pasta/box-v2";
import { type LetterFileCCUserDto, type WriteLetterFileCCUserDto } from "../dto/letter-file-cc-user.dto";
import { defineStore } from "pinia";
import { useLetterFileCCUserApi } from "../http/letter-file-cc-user.api";

export interface LetterFileCCUserStoreState {
  list: CrudList<LetterFileCCUserDto>;
  map: Map<number, LetterFileCCUserDto>;
}

export const useLetterFileCCUserStore = defineStore("LetterFileCCUser", {
  state: (): LetterFileCCUserStoreState => {
    return {
      list: {
        data: [],
        isLastPage: true,
        limit: 10,
        offset: 0,
        page: 1,
        total: 1,
      },
      map: new Map(),
    };
  },
  actions: {
    async fetchList(lfId: number) {
      const list = await useLetterFileCCUserApi().getMany(lfId);
      this.list = list;
      for (const cc of list.data) {
        this.map.set(cc.id, cc);
      }
    },
    async create(dto: WriteLetterFileCCUserDto) {
      await useLetterFileCCUserApi().create(dto);
    },
    async delete(id: number, lfId: number) {
      await useLetterFileCCUserApi().delete(id, lfId);
    },
  },
});
